// ------------------------------------
// Reducer
// ------------------------------------

//LIVE API PATH: api_path: "https://opticalcon-configurator.neutrik.com/api/web/v2/",
//DEV API PATH: api_path: "http://neutrik.raade.at/api/web/v2/"
//LOCAL API PATH: api_path: "http://localhost:8002/v2/"

//LIVE API PATH: optional_attributes_image: "https://opticalcon-configurator.neutrik.com/admin/web/uploads/opticalCONOptionalAttributes.jpg",
//DEV API PATH: optional_attributes_image: "http://neutrik.raade.at/admin/web/uploads/opticalCONOptionalAttributes.jpg"
//LOCAL API PATH: optional_attributes_image: "http://localhost:8001/uploads/opticalCONOptionalAttributes.jpg"

const initialState = {
    api_path: "https://test.opticalcon-configurator.neutrik.com/api/web/v2/",
    sample_image_path: "/assets/img/symbolbild.svg",
    optional_attributes_image: 'https://test.opticalcon-configurator.neutrik.com/admin/web/uploads/opticalCONOptionalAttributes.jpg'
};

const config = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state
    }
}

export default config



// WEBPACK FOOTER //
// ./../../htdocs/neutrik-opticalcon_fe/src/modules/config.js